export var getIconClassName = function getIconClassName(icon, className) {
  return ['dashicon', 'dashicons-' + icon, className].filter(Boolean).join(' ');
};
//# sourceMappingURL=icon-class.js.map